var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgVolumeOnFilled = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.895 4.145c.328.158.537.49.537.855v14.753a.949.949 0 0 1-1.54.74l-5.01-4.007H3a.948.948 0 0 1-.948-.948V9.215c0-.524.424-.948.948-.948h3.882l5.01-4.008a.948.948 0 0 1 1.003-.114Zm7 2.09a.79.79 0 1 0-1.117 1.116 7.107 7.107 0 0 1 0 10.05.79.79 0 0 0 1.117 1.117 8.687 8.687 0 0 0 0-12.283Zm-2.788 2.787a.79.79 0 0 0-1.117 1.117 3.16 3.16 0 0 1 0 4.467.79.79 0 0 0 1.117 1.116 4.738 4.738 0 0 0 0-6.7Z",
    clipRule: "evenodd"
  })));
});
SvgVolumeOnFilled.displayName = "SvgVolumeOnFilled";
export default SvgVolumeOnFilled;